<template>
  <div class="contain">
    <div class="contain_left">
      <el-menu v-model="defaultActiveMenu2" :default-openeds="defaultOpeneds" class="heightP100 zy-menu ">

        <el-submenu v-for="item in menuData" :key="item.id" :index="item.id">
          <template slot="title">
            <span class="collapse-submenu-text">{{ item.label }}</span>
          </template>
          <el-menu-item-group v-if="hasFuApi(item.children)">
            <template slot="title">合约</template>
            <el-menu-item v-for="api in item.children" v-if="api.apiType === '2'" :key="api.id" :index="api.apiId"
              @click="handleTokenClick(api, item.id)">
              <span class="collapse-submenu-text">{{ api.label }}</span>
            </el-menu-item>
            <el-menu-item :key="item.id + '-stats-fu'" :index="item.id + '-stats-fu'"
              @click="handleStatsClickFu(item.id, item.label)">
              <span class="collapse-submenu-text">项目统计</span>
            </el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group v-if="hasSpotApi(item.children)">
            <template slot="title">现货</template>
            <el-menu-item v-for="api in item.children" v-if="api.apiType === '1'" :key="api.id" :index="api.apiId"
              @click="handleTokenClick(api, item.id)">
              <span class="collapse-submenu-text">{{ api.label }}</span>
            </el-menu-item>
            <el-menu-item :key="item.id + '-stats-spot'" :index="item.id + '-stats-spot'"
              @click="handleStatsClickSpot(item.id, item.label)">
              <span class="collapse-submenu-text">项目统计</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <div class="Hcontain_right">
      <div class="div-router">
        <transition name="move" mode="out-in">
          <router-view :key="key"></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import API from "./api";
import dbPermission from "@/proto/dbPermission_pb";
export default {
  name: "Report",
  data() {
    return {
      menuData: [],
      defaultActiveMenu2: "-1",
      defaultOpeneds: [],
      msg: "Welcome to Reporttttttttttttttttttttttt"
    };
  },
  created() {
    // 获取api及币对菜单 await:等待方法执行完成
    this.getMenuData();
  },
  computed: {
    key() {
      return this.$route.path;
    }
  },
  methods: {
    hasFuApi(children) {
      return children && children.some(api => api.apiType === '2');
    },
    hasSpotApi(children) {
      return children && children.some(api => api.apiType === '1');
    },
    handleNodeClick(data) {
      console.log(data);
    },

    handleTokenClick(api, parentId) {
      this.defaultActiveMenu2 = api.apiId;
      if (parentId && !this.defaultOpeneds.includes(parentId)) {
        this.defaultOpeneds.push(parentId);
      }
      const parentItem = this.menuData.find(item => item.id === parentId);
      const apiJson = encodeURIComponent(JSON.stringify(api));
      // this.$router.push(`/token/${api.apiId}/${api.exchange}/${apiJson}`);
      this.$router.push({
        path: `/token/${api.apiId}/${api.exchange}`,
        query: {
          apiJson: encodeURIComponent(JSON.stringify(api))
        }
      });
    },

    // 进入合约项目统计
    handleStatsClickFu(tokenId, tokenLabel) {
      console.log('stats click:', tokenId, tokenLabel);
      this.defaultActiveMenu2 = tokenId + '-stats';
      if (!this.defaultOpeneds.includes(tokenId)) {
        this.defaultOpeneds.push(tokenId);
      }
      this.$router.push(`/stats/${tokenId}/2`);
    },
    // 进入现货项目统计
    handleStatsClickSpot(tokenId, tokenLabel) {
      console.log('stats click:', tokenId, tokenLabel);
      this.defaultActiveMenu2 = tokenId + '-stats';
      if (!this.defaultOpeneds.includes(tokenId)) {
        this.defaultOpeneds.push(tokenId);
      }
      this.$router.push(`/stats/${tokenId}/1`);
    },

    getMenuData() {
      var data = {
        uid: localStorage.getItem("userName"),
        apiType: '0'
      };
      API.getMenu(data)
        .then((res) => {
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message =
              dbPermission.DbPermissionList.deserializeBinary(buffer);
            var menuArray = [];
            message.getPermissionsList().forEach((element) => {
              // console.log('element=', element)
              // 币种
              var token = element.getToken();
              // var uids = element.getUidsList()
              // var banUids = element.getBanuidsList()
              // var deleted = element.getDeleted()
              var item = {
                id: token,
                label: token
              };
              var apiArray = [];
              element.getApisList().forEach((api) => {
                // console.log('api=', api)
                var apiObj = {
                  id: token + "-" + api.getAlias(),
                  baseCurrency: element.getToken(),
                  apiId: api.getId(),
                  label: api.getAlias(),
                  exchange: api.getExchange(),
                  apiType: api.getApitype()
                };
                var symbolArray = [];
                api.getSymbolsList().forEach((symbol) => {
                  var symbolObj = {
                    // id: token + "-" + api.getAlias() + "-" + symbol,
                    // token: token,
                    label: symbol,
                    symbol: symbol,
                    // exchange: api.getExchange(),
                    // apiId: api.getId(),
                    // alias: api.getAlias()
                  };
                  symbolArray.push(symbolObj);
                });
                apiObj.children = symbolArray;
                apiArray.push(apiObj);
              });
              item.children = apiArray;
              menuArray.push(item);
            });
            console.log(menuArray)
            this.menuData = menuArray;
          } else {
            this.loading.close();
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3005) {
              // 无效的登录凭证
              this.$router.push("/login");
            }
          }
        })
        .catch((err) => {
          console.log("err=", err);
          this.loading.close();
          this.$router.push("/login");
        });
    },
  },


};
</script>

<style scoped>
@import "../assets/css/report.scss";
</style>
